import { Action } from 'redux';

import { AddFieldToSortOrder } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface AddFieldToSortOrderAction extends Action {
  field: string;
}

export function addFieldToSortOrder(field: string): AddFieldToSortOrderAction {
  return {
    type: AddFieldToSortOrder,
    field
  };
}

export const isAddFieldToSortOrderAction = isActionFactory<AddFieldToSortOrderAction>(AddFieldToSortOrder);
